import React from 'react';
import { AiFillMinusCircle } from 'react-icons/ai';
import { MdAddCircleOutline } from 'react-icons/md';

const ProductNutritionalInfoForm = ({ formik }) => {
    return (
        // Adicionei 'overflow-hidden' aqui para garantir que o scroll não quebre o layout pai
        <div className="max-w-5xl mx-auto w-full overflow-hidden">
            <NutritionalFactsTable
                value={formik.values.nutrition}
                onChange={(rows) => {
                    formik.setFieldValue('nutrition', rows);
                }}
            />
        </div>
    );
};

const DEFAULT_ROWS = [
    { nutrient: 'Valor Energético', valueInPortion: '', dailyValue: '' },
    { nutrient: 'Carboidratos', valueInPortion: '', dailyValue: '' },
    { nutrient: 'Proteínas', valueInPortion: '', dailyValue: '' },
    { nutrient: 'Gorduras Totais', valueInPortion: '', dailyValue: '' },
    { nutrient: 'Fibra Alimentar', valueInPortion: '', dailyValue: '' },
    { nutrient: 'Sódio', valueInPortion: '', dailyValue: '' },
];

function NutritionalFactsTable({ value = [], onChange }) {
    const tableData = Array.isArray(value) && value.length > 0 ? value : DEFAULT_ROWS;

    const updateRow = (index, field, fieldValue) => {
        const updated = tableData.map((row, i) =>
            i === index ? { ...row, [field]: fieldValue } : row
        );
        onChange(updated);
    };

    const addTableRow = () => {
        onChange([
            ...tableData,
            { nutrient: '', valueInPortion: '', dailyValue: '' },
        ]);
    };

    const removeTableRow = (index) => {
        onChange(tableData.filter((_, i) => i !== index));
    };

   return (
        <div className="w-full">
            <div className="w-full overflow-x-auto shadow-md rounded-lg border border-slate-200">

                {/* ALTERAÇÃO 1: 
                    Mudei de min-w-[600px] para min-w-[340px]. 
                    Isso permite que a tabela encolha para caber em celulares, 
                    mas mantém o scroll se a tela for muito pequena (ex: Galaxy Fold).
                */}
                <table className="table-auto w-full text-xs sm:text-sm min-w-[340px]">
                    <thead>
                        <tr className="bg-custom_blue text-white h-10 font-montserrat text-left">
                            {/* ALTERAÇÃO 2: 
                                Padding responsivo (p-1 no mobile, sm:p-3 no desktop).
                                Isso "gruda" mais as colunas no celular.
                            */}
                            <th className="p-1 sm:p-3 whitespace-nowrap w-5/12">Nutriente</th>
                            <th className="p-1 sm:p-3 whitespace-nowrap w-3/12">Qtde.</th>
                            <th className="p-1 sm:p-3 whitespace-nowrap w-2/12">%VD</th>
                            <th className="p-1 sm:p-3 w-1/12 text-center"></th>
                        </tr>
                    </thead>

                    <tbody className="bg-white">
                        {tableData.map((row, index) => (
                            <tr key={index} className="border-b border-slate-100 hover:bg-slate-50 transition-colors">
                                <td className="p-1 sm:p-2">
                                    <input
                                        type="text"
                                        className="w-full p-1.5 border border-slate-300 rounded focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all text-gray-700"
                                        value={row.nutrient}
                                        placeholder="Nutriente"
                                        onChange={(e) => updateRow(index, 'nutrient', e.target.value)}
                                    />
                                </td>

                                <td className="p-1 sm:p-2">
                                    {/* ALTERAÇÃO 3: 
                                        Removi o 'w-1/3' e voltei para 'w-full'. 
                                        Como a coluna (th) já está estreita (w-3/12), 
                                        o input vai respeitar esse tamanho e ficar pertinho.
                                    */}
                                    <input
                                        type="text"
                                        className="w-full p-1.5 border border-slate-300 rounded focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all text-gray-700"
                                        value={row.valueInPortion}
                                        placeholder="Qtd"
                                        onChange={(e) => updateRow(index, 'valueInPortion', e.target.value)}
                                    />
                                </td>

                                <td className="p-1 sm:p-2">
                                    <input
                                        type="text"
                                        className="w-full p-1.5 border border-slate-300 rounded focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all text-gray-700"
                                        value={row.dailyValue}
                                        placeholder="%"
                                        onChange={(e) => updateRow(index, 'dailyValue', e.target.value)}
                                    />
                                </td>

                                <td className="p-1 sm:p-2 text-center">
                                    <button
                                        type="button"
                                        className="text-custom_red hover:text-red-700 p-1 rounded-full hover:bg-red-50 transition-colors"
                                        onClick={() => removeTableRow(index)}
                                    >
                                        <AiFillMinusCircle size={18} />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="flex justify-start mt-4">
                <button
                    type="button"
                    className="flex items-center bg-blue-600 hover:bg-blue-700 transition-colors text-white text-sm px-6 py-2 rounded shadow-sm"
                    onClick={addTableRow}
                >
                    <MdAddCircleOutline className="mr-2 text-lg" />
                    <span>Adicionar Linha</span>
                </button>
            </div>
        </div>
    );
}

export default NutritionalFactsTable;